/**
 * Compressão de imagem client-side usando Canvas nativo.
 * Sem dependências externas — funciona em todos os browsers modernos.
 */

/**
 * Comprime e redimensiona uma imagem antes do upload.
 *
 * @param {File} file — arquivo de imagem do input
 * @param {Object} opts
 * @param {number} opts.maxWidth — largura máxima em pixels (default: 800)
 * @param {number} opts.quality — qualidade WebP 0-1 (default: 0.82)
 * @returns {Promise<Blob>} — blob comprimido em formato WebP
 */
export function compressImage(file, { maxWidth = 800, quality = 0.82 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        let w = img.width;
        let h = img.height;

        if (w > maxWidth) {
          h = Math.round((h * maxWidth) / w);
          w = maxWidth;
        }

        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);

        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error("Falha na compressão da imagem"));
          },
          "image/webp",
          quality
        );
      } catch (err) {
        reject(err);
      } finally {
        URL.revokeObjectURL(img.src);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error("Falha ao carregar imagem para compressão"));
    };
    img.src = URL.createObjectURL(file);
  });
}
